// @TODO: redo this with Stimulus on page redesign

import EditorJS from "@editorjs/editorjs"
import Header from "@editorjs/header"
import Paragraph from "@editorjs/paragraph"
import Quote from "@editorjs/quote"
import List from "@editorjs/list"
import Table from "@editorjs/table"
import ImageTool from "@editorjs/image"
import Delimiter from "@editorjs/delimiter"
import Underline from "@editorjs/underline"
import Marker from "@editorjs/marker"
import Warning from "@editorjs/warning"
import Embed from "@editorjs/embed"
import { debounce } from "lodash"

import domReady from "../common/utils/dom-ready"

const init = (container, input, editor) => {
  new EditorJS({
    holder: editor,
    data: JSON.parse(input.value),
    tools: {
      embed: {
        class: Embed,
        inlineToolbar: true,
        config: {
          services: {
            youtube: true,
            vimeo: true,
          },
        },
      },
      header: {
        class: Header,
        config: {
          levels: [2, 3],
          defaultLevel: 2
        }
      },
      paragraph:{
        class: Paragraph,
        inlineToolbar: true,
      },
      table: {
        class: Table,
        inlineToolbar: true,
      },
      list: {
        class: List,
        inlineToolbar: true,
        config: {
          defaultStyle: `unordered`,
        },
      },
      image: {
        class: ImageTool,
        config: {
          field: `file`,
          endpoints: {
            byFile: container.dataset.imagesUrl,
            byUrl: container.dataset.imagesUrl,
          },
          additionalRequestHeaders: {
            "X-CSRF-Token": document.querySelector(`meta[name="csrf-token"]`).content,
          },
        }
      },
      quote: Quote,
      warning: Warning,
      Marker: Marker,
      delimiter: Delimiter,
      underline: Underline
    },
    onChange: debounce((api, e) => {
      api.saver.save().then((data) => (input.value = JSON.stringify(data).replaceAll(`&nbsp;`, ` `)))
    }, 200)
  })
}

domReady(() => {
  const containers = document.querySelectorAll(`.editorjs-input`)

  containers.forEach((container) => {
    const input = container.querySelector(`.editorjs-input__input`)
    const editor = container.querySelector(`.editorjs-input__editor`)
    if (input && editor) init(container, input, editor)
  })
})
